import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '../utils/usageTracking';

/** Enregistre les navigations métier (page_view) — à monter une fois dans BusinessRoutes. */
export function useTrackPageView(): void {
  const location = useLocation();

  useEffect(() => {
    trackPageView(location.pathname);
  }, [location.pathname]);
}

export default useTrackPageView;
